import paddleConfig from '../../../security/paddleConfig.json'
export const itemName = (productId) => {
    switch (productId) {
        case paddleConfig.paddleSubscriptionPlanID: return "SchoolPivot Scheduler"
            break;
        case paddleConfig.paddleProductID: return "20 Additional Timetables"
            break;
        default: return productId
    }
}
export const statusText = (status) => {
    switch (status) {
        case "partially_refunded": return "Partially Refunded"
            break;
        case "completed": return "Completed"
            break;
        case "refunded": return "Refunded"
            break;
        default: return ""
    }
}
